export default __webpack_public_path__ + "static/gallery02-0ada2b0988594b01d561fe8e1448b7de.png";